import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import Header from "../components/Header";
import api from "../lib/api";
import { errMsg, Panel } from "../components/admin/ui";

function MemberRow({ m, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const act = async (path, body) => {
    setBusy(true);
    try {
      await api.post(`/admin/members/${m.id}/${path}`, body);
      toast.success(path === "ban" ? `${m.name} diblokir` : `Blokir ${m.name} dicabut`);
      setReason(""); onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <tr data-testid={`member-row-${m.id}`} className="border-b border-[#35353B] align-top">
      <td className="py-3 pr-4 text-[#F5F3ED]">{m.name}<div className="text-xs text-[#A8A8AD] break-all">{m.email}</div></td>
      <td className="py-3 pr-4 text-xs text-[#A8A8AD]">{new Date(m.created_at).toLocaleDateString()}</td>
      <td className="py-3 pr-4">
        {m.banned
          ? <div><span data-testid={`member-status-${m.id}`} className="inline-block px-2 py-0.5 border rounded-sm text-xs text-[#F06464] border-[#F06464]">Diblokir</span>
              <div className="text-xs text-[#A8A8AD] mt-1">{m.banned_reason} · {m.banned_by}</div></div>
          : <span data-testid={`member-status-${m.id}`} className="inline-block px-2 py-0.5 border rounded-sm text-xs text-[#35C78A] border-[#35C78A]">Aktif</span>}
      </td>
      <td className="py-3 text-right">
        {m.banned ? (
          <button data-testid={`member-unban-${m.id}`} disabled={busy} onClick={() => act("unban")} className="text-[#35C78A] hover:underline text-xs disabled:opacity-40">Cabut blokir</button>
        ) : (
          <div className="flex flex-col sm:flex-row gap-2 justify-end">
            <input data-testid={`member-reason-${m.id}`} value={reason} maxLength={500} onChange={(e) => setReason(e.target.value)} placeholder="Alasan blokir (wajib)"
              className="bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-2 py-1 text-xs outline-none focus:border-[#D4AF37]" />
            <button data-testid={`member-ban-${m.id}`} disabled={busy || reason.trim().length < 3} onClick={() => act("ban", { reason })}
              className="border border-[#F06464] text-[#F06464] hover:bg-[#F06464] hover:text-white rounded-sm px-3 py-1 text-xs disabled:opacity-40">Blokir</button>
          </div>
        )}
      </td>
    </tr>
  );
}

export default function Members() {
  const [role, setRole] = useState("buyer");
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => { setSearch(""); }, [role]);
  useEffect(() => {
    const timer = setTimeout(() => {
      api.get("/admin/members", { params: { role, search: search || undefined } }).then((r) => setRows(r.data)).catch(() => toast.error("Gagal memuat pengguna"));
    }, 300);
    return () => clearTimeout(timer);
  }, [role, search]);
  const load = () => api.get("/admin/members", { params: { role, search: search || undefined } }).then((r) => setRows(r.data));

  return (
    <div className="min-h-screen bg-[#101114]">
      <Header />
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-10">
        <h1 className="text-3xl font-bold text-[#F5F3ED] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Kelola Pengguna</h1>
        <p className="text-sm text-[#A8A8AD] mb-6">Akun yang diblokir langsung keluar dari semua perangkat dan tidak bisa login. Pengguna menerima email berisi alasannya.</p>
        <Panel testId="members-panel">
          <div className="flex flex-col sm:flex-row gap-3 mb-4">
            <div className="flex gap-1">
              {[["buyer", "Buyer"], ["supplier", "Supplier"]].map(([k, l]) => (
                <button key={k} data-testid={`members-tab-${k}`} onClick={() => setRole(k)}
                  className={`px-4 py-2 text-sm rounded-sm border ${role === k ? "border-[#D4AF37] text-[#D4AF37]" : "border-[#35353B] text-[#A8A8AD]"}`}>{l}</button>
              ))}
            </div>
            <input data-testid="members-search-input" value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
              placeholder="Cari nama / email" className="flex-1 bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-3 py-2 text-sm outline-none focus:border-[#D4AF37]" />
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs uppercase tracking-widest text-[#A8A8AD] border-b border-[#35353B]">
                <th className="py-2 pr-4">Pengguna</th><th className="py-2 pr-4">Daftar</th><th className="py-2 pr-4">Status</th><th className="py-2 text-right">Aksi</th>
              </tr></thead>
              <tbody>
                {rows.map((m) => <MemberRow key={m.id} m={m} onDone={load} />)}
                {rows.length === 0 && <tr><td colSpan="4" className="py-6 text-center text-[#A8A8AD]">Tidak ada pengguna</td></tr>}
              </tbody>
            </table>
          </div>
        </Panel>
      </div>
    </div>
  );
}
